// clear all SSR artifacts generated by MUI, it's creating conflicts
// @ts-ignore not an issolate module
document
  .querySelectorAll('[data-jss]')
  .forEach(e => e.parentNode && e.parentNode.removeChild(e))
